/**
 * The zehn/docs product mark ("Bold fold"): a solid gradient page chip with a
 * luminous folded ear and etched text lines. Family DNA shared with the other
 * zehn product marks (edge's node mosaic, HR's square mosaic) — same
 * #4185F6→#6FA4F9 gradient, geometric single-shape confidence.
 *
 * The wordmark is real text (not baked into an image), so it follows the
 * theme with no invert filters.
 */
export const DocsMark = ({ size = 20, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <defs>
            <linearGradient id="zehnDocsLogoGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#4185F6" />
                <stop offset="100%" stopColor="#6FA4F9" />
            </linearGradient>
            <linearGradient id="zehnDocsLogoEar" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#8BB5FB" />
                <stop offset="100%" stopColor="#B4D0FD" />
            </linearGradient>
        </defs>
        <path
            d="M6 6.5 A3.5 3.5 0 0 1 9.5 3 H19.5 L26 9.5 V25.5 A3.5 3.5 0 0 1 22.5 29 H9.5 A3.5 3.5 0 0 1 6 25.5 Z"
            fill="url(#zehnDocsLogoGrad)"
        />
        <path
            d="M19.5 3 L26 9.5 H21.5 A2 2 0 0 1 19.5 7.5 Z"
            fill="url(#zehnDocsLogoEar)"
        />
        <g fill="#FFFFFF">
            <rect x="10" y="13" width="12" height="2.4" rx="1.2" opacity="0.95" />
            <rect x="10" y="17.4" width="12" height="2.4" rx="1.2" opacity="0.75" />
            <rect x="10" y="21.8" width="7.5" height="2.4" rx="1.2" opacity="0.55" />
        </g>
    </svg>
);

/** Mark + "zehn/docs" wordmark lockup, matching the sibling products. */
export const DocsLogo = ({ markSize = 20 }) => (
    <span className="flex items-center gap-2 select-none shrink-0">
        <DocsMark size={markSize} />
        <span className="text-sm whitespace-nowrap leading-none">
            <span className="font-semibold text-foreground">zehn</span>
            <span className="font-normal text-[#6FA4F9]">/docs</span>
        </span>
    </span>
);

export default DocsLogo;
